import {isNull} from '@/scripts/helpers/ObjectHelpers';

// Constantes para los errores mas comunes
// Todas estas constantes se evaluaran en la bbdd en Translations.errors[CODE] para mostrar los mensajes traducidos

export const CANT_SEND_EMAIL = newError('ticksy/cant_send_email');
export const FILE_TOO_LARGE = newError('ticksy/file_too_large');
export const INVALID_EMAIL = newError('ticksy/invalid_email');
export const INVALID_EMAIL_AND_PASSWORD = newError('ticksy/invalid_email_and_password');
export const INVALID_FILE = newError('ticksy/invalid_file');
export const INVALID_VALUE = newError('ticksy/invalid_value');
export const LONG_NAME_ALREADY_IN_USE = newError('ticksy/long_name_already_in_use');
export const NAME_ALREADY_IN_USE = newError('ticksy/name_already_in_use');
export const SLUG_ALREADY_IN_USE = newError('ticksy/slug_already_in_use');
export const NAME_AND_SURNAME_ALREADY_IN_USE = newError('ticksy/name_and_surname_already_in_use');
export const NO_RESULTS = newError('ticksy/no_results');
export const NO_USER_CREATED = newError('ticksy/no_user_created');
export const NO_USER_DELETED = newError('ticksy/no_user_deleted');
export const PARSE_ERROR = newError('ticksy/parse_error');
export const PERMISSION_DENIED = newError('permission_denied');
export const REFERENCE_ALREADY_IN_USE = newError('ticksy/reference_already_in_use');
export const SHORT_NAME_ALREADY_IN_USE = newError('ticksy/short_name_already_in_use');
export const SHORTCODE_ALREADY_IN_USE = newError('ticksy/shortcode_already_in_use');
export const TPV_SYNC_ALREADY_IN_USE = newError('ticksy/sync_active_already_in_use');
export const SAME_PCODE_WORKER = newError('ticksy/same_pcode_worker');
export const SAME_DEALER_CODE = newError('ticksy/same_dealer_code');
export const NOT_LANG_LAT_SET = newError('ticksy/no_lang_lat_set');
export const CANT_DOWNLOAD_CHECKOUT = newError('ticksy/cant_download_checkout', 'No se puede descargar la caja');
export const INVALID_DEALER = newError('ticksy/invalid_dealer', 'Código de distribuidor invalido');


// Creo un objeto Error con el Code especificado (el message se traducira al pasar por las traducciones)
export function newError(code) {
  let e = new Error();
  if (!isNull(code)) {
    e.code = code;
  }
  return e;
}

